import {DG_axiosNormal} from "../../../../custom/axios/normal";

const BASE_PATH = '/dogoo/files-manager-rest/v2.0/document-managers';
export const getDocumentsByPkCode = async (params, otherConfig) => {

    const config = {...otherConfig, params};

    const response = await DG_axiosNormal.get(BASE_PATH, config);

    return response?.data || null;
};

export async function deleteDocumentById(id) {

    const response = await DG_axiosNormal.delete(BASE_PATH + `/${id}`);

    return response?.data || [];
}

export async function uploadFile(data, onUploadProgress, config) {

    const response = await DG_axiosNormal.post(
        BASE_PATH + "/file",
        data,
        {headers: {"Content-Type": "multipart/form-data"}, onUploadProgress, ...config})

    return response?.data || []
}

export async function rename(id, data) {

    const response = await DG_axiosNormal.put(BASE_PATH + `/${id}/by-name`, data)

    return response?.data || []
}

export async function getDocumentById(id, category, pkCode, moduleId, appId, fullPath) {

    const response = await DG_axiosNormal.get(BASE_PATH + `/${id}`, {
        params: {
            category,
            pkCode,
            moduleId,
            appId,
            fullPath
        }
    })

    return response?.data || []
}
